import styled from "styled-components";
import yellowBg from "../../assets/images/yellow-bg.png";
import servicesBg from "../../assets/images/servicesBg.svg";

export const ServicesContainer = styled.div`
  /* width: 100%; */
  margin-bottom: 25rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: url(${servicesBg}) no-repeat;
  background-size: cover;
  @media (max-width: 1220px) {
    margin-bottom: 3rem;
  }
`;

export const ServicesFormContainer = styled.div`
  width: 50%;
  padding: 0 1rem;
  h2 {
    font-size: 4.8rem;
    font-weight: 80rem;
    color: var(--primary-color);
    background: url(${yellowBg}) no-repeat 110% 50%;
    margin-bottom: 8rem;
    /* width: 200px; */
    @media (max-width: 1220px) {
      text-align: center;
    }
    @media (max-width: 560px) {
      font-size: 3.4rem;
    }
  }
  p {
    margin-bottom: 2.4rem;
  }
  @media (max-width: 1220px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    align-items: center;
  }
`;

export const ServicesImageContainer = styled.div`
  width: 50%;
  display: flex;
  justify-content: center;

  img {
    max-width: 700px;
    display: block;
  }
  @media (max-width: 1580px) {
    width: 40%;
  }
  @media (max-width: 1330px) {
    width: 30%;
  }
  @media (max-width: 1220px) {
    display: none;
  }
`;

export const PlusServicesContainer = styled.div`
  position: relative;
  height: 100%;
  & div:first-child {
    position: absolute;
    left: 110px;
    bottom: 100px;
  }
  & div:last-child {
    position: absolute;
    left: 10px;
    top: 200px;
  }
`;

export const PlusTopServicesContainer = styled.div`
  position: relative;
  & div:first-child {
    position: absolute;
    right: 100px;
    top: 0px;
  }
  & div:last-child {
    position: absolute;
    right: 290px;
    top: 250px;
  }
`;

export const FormWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
  padding: 2rem 0rem;
  form {
    padding: 0;
  }
  form .button-container {
    display: flex;
    align-items: flex-start !important;
    justify-content: flex-end !important;
  }
  @media (max-width: 1220px) {
    justify-content: center;
    align-items: center;
    form {
      & > div {
        margin-right: 0%;
      }
    }
  }
  
  @media (max-width: 750px) {
    /* scale: 0.8; */
  }
`;
